import { helper } from '@ember/component/helper';

import { get } from 'rise-ui/utils/object.js';

/**
 * Returns available dates for item or model-run
 * @param {Item|ModelRun} [itemOrModelRun]
 * @return {{ from: Date, to: Date }}
 */
export default helper(function availableDatesHelper([ itemOrModelRun ]) {
  return {
    from: itemOrModelRun
      && (get(itemOrModelRun, 'temporalStartDate')
        || get(itemOrModelRun, 'item.temporalStartDate')
      ) || undefined,
    to: itemOrModelRun
      && (get(itemOrModelRun, 'temporalEndDate')
        || get(itemOrModelRun, 'item.temporalEndDate')
      ) || undefined,
  };
});
